import React from 'react';
import { software } from '../data/mock';

const Software = () => {
  // Group by category
  const grouped = software.reduce((acc, item) => {
    if (!acc[item.category]) acc[item.category] = [];
    acc[item.category].push(item);
    return acc;
  }, {});

  return (
    <div>
      <h1 className="text-2xl font-serif mb-8">Software</h1>

      {/* Divider */}
      <div className="border-b border-[#1f1f23] mb-8"></div>

      {/* Software grouped by category */}
      <div className="space-y-8">
        {Object.entries(grouped).map(([category, items]) => (
          <div key={category}>
            <h2 className="text-sm font-medium text-[#8f8fa3] mb-4">{category}</h2>
            <div className="space-y-0">
              {items.map((item) => (
                <div
                  key={item.id}
                  className="py-4 border-b border-[#1f1f23]"
                >
                  <span className="font-medium text-white">{item.name}</span>
                  <span className="text-[#8f8fa3] ml-2">— {item.description}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Software;
